/* BF+ currency display switcher — display-only conversion; checkout stays HKD.
   Client-side only: cache-safe (no server-rendered currency), works on React re-renders. */
(function(){
  if (window.__bfCur) return; window.__bfCur = 1;
  var EN = location.pathname.indexOf('/en') === 0;
  var CURS = [
    {c:'HKD', s:'HK$',  zh:'港幣 HKD',    en:'HKD Hong Kong Dollar'},
    {c:'USD', s:'US$',  zh:'美元 USD',    en:'USD US Dollar'},
    {c:'EUR', s:'€',    zh:'歐元 EUR',    en:'EUR Euro'},
    {c:'GBP', s:'£',    zh:'英鎊 GBP',    en:'GBP British Pound'},
    {c:'JPY', s:'¥',    zh:'日圓 JPY',    en:'JPY Japanese Yen'},
    {c:'CNY', s:'CN¥',  zh:'人民幣 CNY',  en:'CNY Chinese Yuan'},
    {c:'TWD', s:'NT$',  zh:'新台幣 TWD',  en:'TWD New Taiwan Dollar'},
    {c:'SGD', s:'S$',   zh:'新加坡元 SGD', en:'SGD Singapore Dollar'},
    {c:'AUD', s:'A$',   zh:'澳元 AUD',    en:'AUD Australian Dollar'},
    {c:'CAD', s:'C$',   zh:'加元 CAD',    en:'CAD Canadian Dollar'}
  ];
  var FALLBACK = {USD:0.128,EUR:0.117,GBP:0.100,JPY:19.8,CNY:0.92,TWD:4.05,SGD:0.171,AUD:0.192,CAD:0.174,HKD:1};
  var rates = FALLBACK, sel = 'HKD';
  try { sel = localStorage.getItem('bf_cur') || 'HKD'; } catch(e){}
  try {
    var cached = JSON.parse(localStorage.getItem('bf_cur_rates') || 'null');
    if (cached && cached.t && (Date.now() - cached.t) < 864e5) rates = cached.r;
    else fetch('https://open.er-api.com/v6/latest/HKD').then(function(r){return r.json();}).then(function(j){
      if (j && j.rates) { rates = j.rates; try{ localStorage.setItem('bf_cur_rates', JSON.stringify({t:Date.now(), r:j.rates})); }catch(e){}; if (sel!=='HKD') applyAll(); }
    }).catch(function(){});
  } catch(e){}

  var RE = /HKD\s?([0-9][0-9,]*(?:\.[0-9]+)?)/g;
  var originals = new WeakMap();
  function convTxt(txt){
    return txt.replace(RE, function(m, num){
      var v = parseFloat(num.replace(/,/g,'')); if (!isFinite(v)) return m;
      var rate = rates[sel] || FALLBACK[sel]; if (!rate) return m;
      var cur = null; for (var i=0;i<CURS.length;i++) if (CURS[i].c===sel) cur=CURS[i];
      var out = Math.round(v*rate);
      return '≈' + cur.s + out.toLocaleString('en-US');
    });
  }
  function walk(root, fn){
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {acceptNode:function(n){
      var p = n.parentElement; if (!p) return NodeFilter.FILTER_REJECT;
      var tag = p.tagName; if (tag==='SCRIPT'||tag==='STYLE'||tag==='TEXTAREA') return NodeFilter.FILTER_REJECT;
      if (p.closest && p.closest('#bfCurWrap')) return NodeFilter.FILTER_REJECT;
      return NodeFilter.FILTER_ACCEPT;
    }});
    var n; var list=[]; while ((n=w.nextNode())) list.push(n);
    list.forEach(fn);
  }
  var elOrig = new WeakMap();
  function applySplit(){
    var els = document.body.querySelectorAll('*');
    for (var i=0;i<els.length;i++){
      var el = els[i];
      if (el.children.length) continue;
      if (el.childNodes.length < 2) continue;
      if (el.closest && el.closest('#bfCurWrap')) continue;
      var tag = el.tagName; if (tag==='SCRIPT'||tag==='STYLE'||tag==='TEXTAREA') continue;
      var combined = el.textContent;
      var saved = elOrig.get(el);
      var base = (saved != null) ? saved : combined;
      if (!/HKD\s?[0-9]/.test(base)) continue;
      if (sel === 'HKD') {
        if (saved != null && combined !== saved) el.textContent = saved;
        continue;
      }
      if (saved == null) elOrig.set(el, combined);
      var out = convTxt(base);
      if (combined !== out) el.textContent = out;
    }
  }
  function applyAll(){
    applySplit();
    walk(document.body, function(n){
      var orig = originals.get(n);
      if (sel === 'HKD') { if (orig != null && n.nodeValue !== orig) n.nodeValue = orig; return; }
      var base = (orig != null) ? orig : n.nodeValue;
      if (!/HKD\s?[0-9]/.test(base)) return;
      if (orig == null) originals.set(n, n.nodeValue);
      var out = convTxt(base);
      if (n.nodeValue !== out) n.nodeValue = out;
    });
    var lab = document.getElementById('bfCurLab');
    if (lab) { var cur=null; for (var i=0;i<CURS.length;i++) if (CURS[i].c===sel) cur=CURS[i]; lab.textContent = cur ? cur.s+' '+cur.c : sel; }
  }
  var pending = null;
  var obs = new MutationObserver(function(){
    if (sel === 'HKD') return;
    if (pending) return;
    pending = setTimeout(function(){ pending=null; applyAll(); }, 250);
  });

  function ui(){
    var wrap = document.createElement('div');
    wrap.id = 'bfCurWrap';
    wrap.innerHTML =
      '<button id="bfCurBtn" type="button" aria-haspopup="listbox" aria-label="'+(EN?'Change display currency':'切換顯示貨幣')+'">'+
        '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M3.5 9h17M3.5 15h17M12 3a17 17 0 0 1 0 18M12 3a17 17 0 0 0 0 18"/></svg>'+
        '<span id="bfCurLab">HK$ HKD</span></button>'+
      '<div id="bfCurMenu" role="listbox" hidden></div>';
    var css = document.createElement('style');
    css.textContent =
      '#bfCurWrap{position:fixed;left:14px;bottom:92px;z-index:9990;font-family:"DM Sans","Noto Sans TC",sans-serif;}'+
      'body:has(#navLinks.open) #bfCurWrap,body:has(#drawer.open) #bfCurWrap,body.bf-drawer-open #bfCurWrap{display:none!important;}'+
      '#bfCurBtn{display:inline-flex;align-items:center;gap:6px;padding:9px 13px;border-radius:999px;border:1px solid rgba(20,28,24,.16);background:rgba(252,250,244,.96);color:#2c2a26;font-size:11.5px;font-weight:700;letter-spacing:.06em;cursor:pointer;box-shadow:0 4px 16px rgba(20,28,24,.13);backdrop-filter:blur(6px);}'+
      '#bfCurBtn:hover{border-color:rgba(20,28,24,.34);}'+
      '#bfCurMenu{position:absolute;left:0;bottom:44px;min-width:198px;max-height:52vh;overflow-y:auto;background:#fffdf8;border:1px solid rgba(20,28,24,.14);border-radius:12px;box-shadow:0 10px 34px rgba(20,28,24,.18);padding:6px;}'+
      '#bfCurMenu button{display:block;width:100%;text-align:left;padding:9px 12px;border:none;background:none;border-radius:8px;font-size:12.5px;color:#2c2a26;cursor:pointer;font-family:inherit;}'+
      '#bfCurMenu button:hover{background:rgba(212,151,74,.12);}'+
      '#bfCurMenu button.on{background:rgba(212,151,74,.18);font-weight:700;}'+
      '#bfCurNote{padding:8px 12px 6px;font-size:10px;color:#8a857c;line-height:1.5;border-top:1px solid rgba(20,28,24,.08);margin-top:4px;}'+
      '#bfCurWrap.bf-mini #bfCurLab{display:none;}'+
      '#bfCurWrap.bf-mini #bfCurBtn{width:44px;height:44px;padding:0;justify-content:center;}';
    document.head.appendChild(css);
    document.body.appendChild(wrap);
    var btn = document.getElementById('bfCurBtn'), menu = document.getElementById('bfCurMenu');
    function build(){
      menu.innerHTML = CURS.map(function(c){
        return '<button type="button" role="option" data-c="'+c.c+'" class="'+(c.c===sel?'on':'')+'">'+(EN?c.en:c.zh)+'</button>';
      }).join('') + '<div id="bfCurNote">'+(EN?'Estimates for reference only.<br>Checkout is in HKD.':'折算價只供參考<br>結帳一律以港幣 HKD 進行')+'</div>';
    }
    btn.addEventListener('click', function(e){ e.stopPropagation(); wrap.classList.remove('bf-mini'); build(); menu.hidden = !menu.hidden; });
    menu.addEventListener('click', function(e){
      var b = e.target.closest('button[data-c]'); if (!b) return;
      sel = b.getAttribute('data-c');
      try{ localStorage.setItem('bf_cur', sel); }catch(err){}
      menu.hidden = true;
      applyAll();
    });
    document.addEventListener('click', function(){ if (!menu.hidden) menu.hidden = true; });
    document.addEventListener('click', function(){ setTimeout(function(){
      var nl=document.getElementById('navLinks'), dr=document.getElementById('drawer');
      var open=(nl&&nl.classList.contains('open'))||(dr&&dr.classList.contains('open'));
      document.body.classList.toggle('bf-drawer-open', !!open);
    }, 250); }, true);
    var onScroll=function(){ if(!menu.hidden){ wrap.classList.remove('bf-mini'); return; } wrap.classList.toggle('bf-mini', (window.scrollY||0)>60); };
    window.addEventListener('scroll', onScroll, {passive:true}); onScroll();
    applyAll();
    obs.observe(document.body, {childList:true, subtree:true, characterData:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ui); else ui();
})();
